import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useProgramsPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canCreate, canUpdate, canDelete, canCreateProgramBroadcast } = useMemo(
    () => ({
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_PROGRAM]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_PROGRAM]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_PROGRAM]),
      canCreateProgramBroadcast: hasPlatformPermission([
        PERMISSIONS.MEDIA_MANAGER.CREATE_PROGRAM_BROADCAST,
      ]),
    }),
    [hasPlatformPermission]
  );

  return {
    canCreate,
    canUpdate,
    canDelete,
    canCreateProgramBroadcast,
  };
};
